// extracted by mini-css-extract-plugin
module.exports = {"list-grid":"list-grid_list-grid__W7MLR"};